import React from 'react';
import PassButton from '../../commons/passButton'; // Import the PassButton component
import ScanAllButton from '../../commons/scanAllButton';
import { checkUnScannedSku } from './scanBarcodeFunctions';
import { useDispatch } from 'react-redux';
import saveLogReducer from '../../reducers/saveLogReducer';
import { OFFLINE_MESSAGE } from '../../constants';
import I18n from 'i18n-js';

const ScanButtonContainer  = ({
    Order,
    popInternet,
    scanAllItem,
    windowWidth,
    setType,
    checkCount,
    scanAllOption,
    typeScanState,
    handlePassButton,
    isBarcodeEnter,
    setIsBarcodeEnter,
  }) => {
    const disPatch = useDispatch()

  const shouldRenderPassButton =
    isBarcodeEnter === false ||
    scanAllOption === false ||
    checkUnScannedSku(Order, typeScanState) ||
    checkCount();

  const handleOnPress = (item, isShiftKey) =>{
    handlePassButton(item, isShiftKey);
  }

  const checkButtonDisabled = (Order) => {
    if (Order?.unscanned_items[0]?.child_items.length > 0) {
      return Order.unscanned_items[0].child_items[0].click_scan_enabled === 'on';
    }
    return Order?.unscanned_items[0]?.click_scan_enabled === 'on';
  };
  

  return (
    <>
      {(shouldRenderPassButton) ? (
        <PassButton
          orderItem={Order.unscanned_items[0]}
          order={Order}
          onPress={(item, isShiftKey = false) => {
       
            if(Order.unscanned_items.length === 1 && !popInternet){
              disPatch({type : OFFLINE_MESSAGE, payload : I18n.t("scanpackItem.uploadSyncLabel")})
            }
                handleOnPress(item, isShiftKey)
          }}
          onLongPress={scanAllItem}
          windowWidth={windowWidth}
        />
      ) : (
        <ScanAllButton
          onPress={() => {
            setType('scan_all_items');
            scanAllItem();
            checkButtonDisabled(Order) && setIsBarcodeEnter();
          }}
          order={Order}
          windowWidth={windowWidth}
          orderItem={Order.unscanned_items[0]}
        />
      )}
    </>
  )
};

export default ScanButtonContainer;
